import React from 'react'
import ExitToAppOutlined from '@material-ui/icons/ExitToAppOutlined'

export default function AccountTreeOutlinedIcon() {

    return (
        <ExitToAppOutlined />
    )
}